export const SAVE_CLIENTS_LIST = 'SAVE_CLIENTS_LIST'; 
export const SAVE_CLIENT_DETAILS = 'SAVE_CLIENT_DETAILS'; 